import qrtigerLogo from '../../../assets/qrtiger.png';
import menutigerLogo from '../../../assets/menutiger.jpeg';
import { PRODUCTS } from '../slice/constants';

import { selectCurrentProduct } from '../slice/selectors';
import { useDispatch, useSelector } from 'react-redux';
import { usePortalSlice } from '../slice';
import { useChatSlice } from '../../../containers/chat/slice';
import { useEffect, useState } from 'react';

export default function useProductsProvider() {
  const currentProduct = useSelector(selectCurrentProduct);
  const dispatch = useDispatch();
  const { actions } = usePortalSlice();
  const { actions: chatActions } = useChatSlice();
  const [parentUrl, setParentUrl] = useState<string | null>(null);
  const setCurrentProduct = (product: (typeof PRODUCTS)[keyof typeof PRODUCTS]) => {
    dispatch(actions.setCurrentProduct(product));
    dispatch(chatActions.onNewChat());
  };
  const products: any[] = [
    { id: PRODUCTS.MENUTIGER, name: 'MenuTiger', avatarUrl: menutigerLogo },
    { id: PRODUCTS.QRTIGER, name: 'QRTiger', avatarUrl: qrtigerLogo },
  ];
useEffect(() => {
  const parentAppUrl = localStorage.getItem(`parentAppUrl-${process.env.REACT_APP_PUBLIC_URL}`);
  if (parentAppUrl) {
    setParentUrl(parentAppUrl);
  }
}, []);
  const productBasedQuestions = {
    [PRODUCTS.MENUTIGER]: [
      'How do I create a digital menu with QR codes for my restaurant?',
      'Can customers place orders directly after scanning the QR code?',
      'How do I connect Stripe or other payments to my menu?',
      'What kind of sales and order reports can I see in the backend?',
      'Can I update my menu in real time without reprinting QR codes?',
      'How do I manage multiple branches or menus in one account?',
      'Which plan is best for my restaurant?',
      'How do I collect customer feedback through Menu Tiger?',
    ],
    [PRODUCTS.QRTIGER]:parentUrl==="https://vcard-app.qrcode-tiger.com"?['How do I create a vCard QR Code with my contact details? (e.g., what information I need to input, like name, phone, email, company, etc.)', 'Can I edit or update my vCard QR Code after it’s been generated?', 'Is the vCard QR Code compatible with all phones and contact apps (iPhone, Android, etc.)?', 'Can I customize the design of my vCard QR Code (colors, logo, frame)?', 'Does the QR Code expire, or is it permanent once generated?', 'How can I download and use my vCard QR Code (in business cards, email signatures, websites)?']: ['How do I create a QR code for my business?', 'How do I track scans and analytics from my QR codes?', 'What’s the difference between static and dynamic QR codes?', 'How can I add my logo and brand colors to a QR code?', 'How do businesses use QR codes for marketing campaigns?', 'Which plan is right for my business?', 'What kind of analytics and user data can I track using dynamic QR codes?'],
  };

  const productBasedChatPlaceholder = {
    [PRODUCTS.MENUTIGER]: 'Chat with a consultant on how MenuTiger can help increase your revenue',
    [PRODUCTS.QRTIGER]: 'Chat with your data or ask questions to improve your campaigns',
  };

  const colorThemes = {
    // menu tiger's theme is green

    [PRODUCTS.MENUTIGER]: {
      primary: {
        main: '#00b692',
        dark: '#00b86b',
        light: '#00b86b',
        contrastText: '#ffffff',
      },
      secondary: {
        main: '#00b86b',
        dark: '#00b86b',
        light: '#00b86b',
        contrastText: '#ffffff',
      },
    },
    [PRODUCTS.QRTIGER]: {
      primary: {
        main: '#3B82F6', // Stripe's primary purple
        dark: '#3a33c5',
        light: '#dddcf5a6',
        contrastText: '#ffffff',
      },
      secondary: {
        main: '#00b86b', // Stripe's success green
      },
    },
  };
  return { products, currentProduct, setCurrentProduct, productBasedQuestions, colorThemes, productBasedChatPlaceholder, parentUrl };
}
